import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatDuration',
    standalone: true
})
export class FormatDurationPipe implements PipeTransform {

    transform(value: number): string {
        if (value === null || value === undefined) return '';

        // Ensure value is treated as a number
        const totalHours = Number(value);

        if (isNaN(totalHours) || totalHours === 0) {
            return '0m';
        }

        const hours = Math.floor(totalHours);
        const minutes = Math.round((totalHours - hours) * 60);

        // Handle case where minutes rounding adds an hour (e.g. 0.99 hours -> 60 mins -> 1 hour)
        if (minutes === 60) {
            return `${hours + 1}h`;
        }

        if (hours > 0) {
            return minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`;
        } else {
            return `${minutes}m`;
        }
    }
}
